export const environment = {
	production: true,
};

export type Environment = typeof environment;
